module.exports = __webpack_public_path__ + "static/media/Portraits-2.641c79d6.jpg";